import React from 'react'

export const SDKContext = React.createContext(null)
